import { createLoggerInterceptor } from "@/config/axios-logger";
import { wobaLogger } from "@/config/woba-logger";

import { apiLegacy } from "@/services/api-legacy";
import { apiWobaBackend } from "@/services/api-woba-backend";
import { apiBookingManager } from "@/services/api-booking-manager";
import { apiSearchMs } from "@/services/api-search-ms";
import { apiVision360 } from "@/services/api-vision360";
import { apiHubspotIntegrationMs } from "@/services/api-hubspot-integration-ms";
import { apiBackofficeReportsMs } from "@/services/api-backoffice-reports-ms";
import { apiInventoryRequests } from "@/services/api-inventory-requests";
import { apiWobaInventory } from "@/services/api-woba-inventory";
import { apiVision } from "@/services/vision-service/api-vision";

/**
 * Registers the HTTP-logging interceptor on every axios instance in one place,
 * so the service modules stay free of observability wiring. Imported for its
 * side effect at app startup (see main.tsx).
 */
const instances = [
  apiLegacy,
  apiWobaBackend,
  apiBookingManager,
  apiSearchMs,
  apiVision360,
  apiHubspotIntegrationMs,
  apiBackofficeReportsMs,
  apiInventoryRequests,
  apiWobaInventory,
  apiVision,
];

instances.forEach((instance) => createLoggerInterceptor(instance, wobaLogger));
